// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryButton_container__33hdf","title":"PrimaryButton_title__3iP1J","subtitle":"PrimaryButton_subtitle__Tdhg8"};